module.exports = __webpack_public_path__ + "img/group-avator.dff86402.svg";